import React from 'react';
import { useSelector } from 'react-redux';

import { selectCommon } from '../../../store/common';
import MentorProfile from '../../components/mentor-profile';
import useMentorDrawer from '../../components/mentor-card/use-mentor-drawer';
import {
  OfferingSiderContent,
  useOfferingDrawer,
} from '../../components/offering-side-drawer';
import SideDrawer from '../side-drawer';

const AppDrawer = () => {
  const { mentor } = useSelector(selectCommon);
  const { offering } = useSelector(selectCommon);
  const mentorDrawer = useMentorDrawer();
  const offeringDrawer = useOfferingDrawer();

  const toggleDrawer = !!offering || !!mentor;

  const onClose = () => {
    if (mentor) {
      mentorDrawer.onClose();
    }
    if (offering) {
      offeringDrawer.onClose();
    }
  };

  return (
    <SideDrawer
      toggleDrawer={toggleDrawer}
      onClose={onClose}
      {...(!!mentor && mentorDrawer)}
      {...(!!offering && offeringDrawer)}
    >
      {mentor && (
        <MentorProfile
          onClose={mentorDrawer.onClose}
          mentor={mentor}
          scrolled={mentorDrawer.scrolled}
        />
      )}
      {offering && (
        <OfferingSiderContent
          onClose={offeringDrawer.onClose}
          scrolled={offeringDrawer.scrolled}
          page={offeringDrawer.page}
        />
      )}
    </SideDrawer>
  );
};

export default AppDrawer;
